// import React from "react";
// import ReactDOM from "react-dom/client";
// import App from "./App";
// import { Provider } from "react-redux";
// import store from "./store";
// import { BrowserRouter } from "react-router-dom";
// import "react-confirm-alert/src/react-confirm-alert.css"
// import 'react-drawer/lib/react-drawer.css';
// import 'react-phone-input-2/lib/style.css'
// import "./i18n"
// import "./Css/main.css"

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <Provider store={store}>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </Provider>,
// );


import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter } from "react-router-dom";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-drawer/lib/react-drawer.css";
import "react-phone-input-2/lib/style.css";
import "./i18n";
import "./Css/main.css";
import { HelmetProvider } from "react-helmet-async";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </BrowserRouter>
  </Provider>
);
